import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Filter from '../filter/filter';
import DateFilter from '../date-filter/date-filter';
import Button from '../button/button';

import styles from './content-filter.module.scss';

export default class ContentFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFilters: {
        field_tags: {},  // eslint-disable-line camelcase
        field_series: {},  // eslint-disable-line camelcase
        field_venue: {},  // eslint-disable-line camelcase
        field_presented_by: {}, // eslint-disable-line camelcase
        field_distance: {},  // eslint-disable-line camelcase **Dining Filter**
        field_experience: {},  // eslint-disable-line camelcase **Dining Filter**
        field_cuisine: {},  // eslint-disable-line camelcase **Dining Filter**
      },
      startDate: null,
      endDate: null,
      focusedInput: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.isFilterActive = this.isFilterActive.bind(this);
    this.handleDateUpdate = this.handleDateUpdate.bind(this);
    this.handleDateSubmit = this.handleDateSubmit.bind(this);
    this.submitFilter = this.submitFilter.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  handleInputChange(event, field) {
    const target = event.target;

    this.setState((prevState) => ({
      selectedFilters: {
        ...prevState.selectedFilters,
        [field]: {
          ...prevState.selectedFilters[field],
          [target.id]: target.checked,
        },
      },
    }));
  }

  handleDateUpdate(newState) {
    this.setState(newState);
  }

  handleDateSubmit(event) {
    event.preventDefault();
    this.props.updateContent({
      selectedDates: {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        focusedInput: this.state.focusedInput,
      },
    });
  }

  submitFilter(event) {
    event.preventDefault();
    this.props.updateContent({
      selectedFilters: this.state.selectedFilters,
    });
  }

  isFilterActive(selectedFilterItems) {
    if (!selectedFilterItems) return false; // Fix for "cannot convert undefined or null to object"
    return Object.values(selectedFilterItems).some((item) => item);
  }

  clearFilters(event) {
    event.preventDefault();

    this.setState({
      selectedFilters: {
        field_tags: {},
        field_series: {},
        field_venue: {},
        field_presented_by: {},
        field_distance: {},
        field_experience: {},
        field_cuisine: {},
      },
      startDate: null,
      endDate: null,
      focusedInput: null,
    });

    this.props.resetResults();
  }

 

  render() {
    const { filters, allEvents, currentEvents, isDining } = this.props;

    // **EVENTS FILTER LOGIC**
    const uniqueVenues = new Set(
      currentEvents.flatMap((event) => {
        const relationships = event.node.relationships;
        return [
          relationships.field_venue?.title,
          ...(Array.isArray(relationships.field_venues)
            ? relationships.field_venues.map((venue) => venue.title).filter(Boolean)
            : []),
        ].filter(Boolean);
      })
    );

    const uniqueEventTags = new Set(
      currentEvents.flatMap((event) => {
        const relationships = event.node.relationships;
        return Array.isArray(relationships.field_tags)
          ? relationships.field_tags.map((tag) => tag.name).filter(Boolean)
          : [];
      })
    );

    const uniqueEventSeries = new Set(
      currentEvents
        .map((event) => event.node.relationships.field_series?.name)
        .filter(Boolean)
    );

    const uniquePresenter = new Set(
      currentEvents
        .map((event) => event.node.relationships.field_presented_by?.title)
        .filter(Boolean)
    );

    // **DINING FILTER LOGIC**
    const uniqueCuisines = new Set(
      currentEvents.flatMap((event) => {
        if (event.node.__typename === "node__dining") {
          return (
            event.node.relationships?.field_cuisine?.flatMap((cuisine) =>
              cuisine.metatag?.map((meta) => meta.attributes?.content)
            ) || []
          );
        }
        return [];
      })
    );
    
    const uniqueDistances = new Set(
      currentEvents.flatMap((event) => {
        if (event.node.__typename === "node__dining") {
          return (
            event.node.relationships?.field_distance?.metatag?.map((meta) =>
              meta.attributes?.content
            ) || []
          );
        }
        return [];
      })
    );

    const uniqueExperiences = new Set(
      currentEvents.flatMap((event) => {
        if (event.node.__typename === "node__dining") {
          return (
            event.node.relationships?.field_experience?.metatag?.map(
              (meta) => meta.attributes?.content
            ) || []
          );
        }
        return [];
      })
    );
    return (
      <div className={styles.filters}>
        <div className={styles.filterContainer}>
          <p className={styles.label}>{this.props.desc}:</p>
          <ul className={styles.list}>
            {filters &&
              filters.map((filter, key) => {            

                const filteredData = filter.data.filter((item) => {
                  if (!item.node) {
                    return false;
                  }
                  // if data is missing check how its being added in graphQL 
                  // make sure data is being brought in by the edges.
                
                  let itemName = item.node.name || item.node.title;

                  // If the field is experience or cuisine, get the metatag content
                  if (filter.field === "field_experience" || filter.field === "field_cuisine") {
                    itemName = item.node.metatag?.map((meta) => meta.attributes?.content) || [];
                  }
                  
                  // If itemName is still falsy, return false
                  if (!itemName || (Array.isArray(itemName) && itemName.length === 0)) return false;
                
                
                  // **Event Filters**
                  if (filter.field === "field_venue") {
                    return uniqueVenues.has(itemName);
                  } else if (filter.field === "field_tags") {
                    return uniqueEventTags.has(itemName);
                  } else if (filter.field === "field_series") {
                    return uniqueEventSeries.has(itemName);
                  } else if (filter.field === "field_presented_by") {
                    return uniquePresenter.has(itemName);
                  }
                
                  // **Dining Filters**
                  if (isDining) {
                    if (filter.field === "field_cuisine") {
                      itemName = item.node.metatag?.map((meta) => meta.attributes?.content).filter(Boolean) || [];
                      if (itemName.length === 0) return false;
                      return itemName.some((name) => uniqueCuisines.has(name));
                    }

                    if (filter.field === "field_experience") {
                      itemName = item.node.metatag?.[0]?.attributes?.content || "";
                      if (!itemName) return false;
                      return uniqueExperiences.has(itemName);
                    }

                    if (filter.field === "field_distance") {
                      itemName = item.node.name || item.node.title || item.node.metatag?.[0]?.attributes?.content || "";
                      if (!itemName) return false;
                      return uniqueDistances.has(itemName);
                    }
                  }
    
                  return true;
                });

                const sortedData = filteredData.sort((a, b) => {
                  const getName = (node) => {
                    if (filter.field === "field_experience" || filter.field === "field_cuisine") {
                      return node.metatag?.map((meta) => meta.attributes?.content).join(", ") || "";
                    }
                    return node.name || node.title || "";
                  };

                  const nameA = getName(a.node);
                  const nameB = getName(b.node);

                  // Custom order for dining distance filter.
                  if (filter.field === "field_distance") {
                    const distanceOrder = {
                      'On Site': 0,
                      'Less than 5 Minute Walk': 1,
                      '5-10 minute walk': 2
                    };

                    const rankA = distanceOrder[nameA] ?? 999;
                    const rankB = distanceOrder[nameB] ?? 999;

                    if (rankA !== rankB) {
                      return rankA - rankB;
                    }
                  }

                  return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
                });
                
                const sortedFilter = {
                  ...filter,
                  data: sortedData.map((item) => ({
                    ...item,
                    node: {
                      ...item.node,
                      name:
                      filter.field === "field_cuisine"
                        ? item.node.metatag?.map((meta) => meta.attributes?.content).filter(Boolean).join(", ")
                        : filter.field === "field_experience"
                          ? item.node.metatag?.[0]?.attributes?.content || ""
                          : item.node.name || item.node.title || item.node.metatag?.[0]?.attributes?.content || "",
                    },
                  })),
                };

                return (
                  <Filter
                    handleInputChange={this.handleInputChange}
                    submitFilter={this.submitFilter}
                    selectedFilters={this.state.selectedFilters[filter.field]}
                    key={`filter-${filter.field}-${key}`}
                    filter={sortedFilter}
                    isActive={this.isFilterActive(
                      this.state.selectedFilters[filter.field]
                    )}
                  />
                );
              })}

            {/* **Only show DateFilter for Events** */}
            {!isDining && (
              <DateFilter
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                focusedInput={this.state.focusedInput}
                handleDateUpdate={this.handleDateUpdate}
                handleDateSubmit={this.handleDateSubmit}
              />
            )}

            {/* Show the Clear Filters button if any filters are active */}
            {this.props.isFiltered && (
              <Button className={styles.clear} size="small" onClick={this.clearFilters}>
                Clear Filters
              </Button>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

ContentFilter.propTypes = {
  filters: PropTypes.array,
  desc: PropTypes.string.isRequired,
  updateContent: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool,
  resetResults: PropTypes.func,
  allEvents: PropTypes.array.isRequired,
  currentEvents: PropTypes.array.isRequired,
  isDining: PropTypes.bool.isRequired,
};